import { BlocEvent } from "src/app/shared/bloc/base-bloc";
import { PaginationFilter } from "src/app/shared/interfaces";

export abstract class HeaderEvent extends BlocEvent {
}
export class HeaderLogOutEvent extends HeaderEvent {
}